/**
 * @fileoverview Global CSS for FW custom components.
 * Uses `<Global />` from emotion to inject CSS to custom
 * component Shadow DOM root.
 */
import { css, Global } from '@emotion/core';
import { createFocusOutlineFixStyle } from '@core/accessibility';
const CSS_RESET = css `
  all: initial;
  font-family: inherit;
`;
const GLOBAL_STYLE = css `
  --primary: var(--fw-primary, #0f6bff);
  --primary-rgb: 254, 57, 82;
  --secondary: #121212;
  --secondary-rgb: 18, 18, 18;

  --blk1: #121212;
  --blk1-rgb: 18, 18, 18;
  --gray1: #171717;
  --gray1-rgb: 23, 23, 23;
  --gray2: #2b2b2b;
  --gray2-rgb: 43, 43, 43;
  --gray3: #404040;
  --gray3-rgb: 64, 64, 64;
  --gray4: #9b9b9b;
  --gray4-rgb: 155, 155, 155;
  --gray5: #bdbdbd;
  --gray5-rgb: 189, 189, 189;

  --business-crimson: #f40c70;

  --gradient: var(
    --fw-gradient,
    linear-gradient(97.33deg, #0f6bff -57.16%, #0f6bff 149.26%)
  );
  --background: rgba(0, 0, 0, 0.8);
  --badge-highlight: #fe3952;

  * {
    box-sizing: border-box;
  }

  video::cue {
    background: transparent;
    visibility: hidden;
    font-size: 0.001px;
  }

  ${createFocusOutlineFixStyle()}
`;
export function GlobalCustomCSS(props) {
    const { params, scope = ':host' } = props;
    return (<>
      <Global styles={css `
          ${scope} {
            ${CSS_RESET}
            ${params.ui_font_css
            ? css `
                  @import url('${params.ui_font_css}');
                `
            : ''}

            ${params.ui_primary_color
            ? css `
                  --fw-button-color: ${params.ui_primary_color};
                  --fw-primary: ${params.ui_primary_color};
                  --fw-gradient: linear-gradient(
                    ${params.ui_primary_color},
                    ${params.ui_primary_color}
                  );
                `
            : ''}

              ${params.ui_button_color
            ? css `
                  --fw-button-color: ${params.ui_button_color};
                `
            : ''}

              ${params.ui_button_font_color
            ? css `
                  --fw-button-font-color: ${params.ui_button_font_color};
                `
            : ''}

            ${GLOBAL_STYLE}
          }
        `}/>
    </>);
}
